import { useQuery, useQueryClient } from 'react-query';
import { QUERY_KEYS } from '../constants';
import { Http } from '../../services/Http';
import { DealWithTimeLogs } from '../../types';

async function fetchDealOwnerOpChargeSummary(
  year: number,
  month: number
): Promise<DealWithTimeLogs[]> {
  const { data } = await Http.axios.get<DealWithTimeLogs[]>(
    `/deal/op-charge-summary?year=${year}&month=${month}`
  );
  return data;
}

export const useDealOwnerDealsWithTimeLogs = (year: number, month: number) => {
  return useQuery(
    [QUERY_KEYS.DEAL_OWNER_OP_CHARGE_SUMMARY, year, month],
    () => fetchDealOwnerOpChargeSummary(year, month),
    {
      staleTime: Infinity,
      enabled: !!year,
      refetchInterval: false,
      refetchOnMount: true,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      refetchIntervalInBackground: false,
    }
  );
};

export const useInvalidateOpManagerTimesheetsSummaryData = () => {
  const queryClient = useQueryClient();

  return () => {
    queryClient.invalidateQueries({
      queryKey: QUERY_KEYS.OP_MANAGER_TIMESHEETS_SUMMARY,
    });
  };
};
